export default {
  path: '/devOpsManage',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/devOpsManage/home',
  children: [
    {
      // 首页
      path: 'index',
      name: 'devOpsManage/index',
      component: () => import('./index')
    },
    {
      // 尽调审批
      path: 'dueDiligence',
      name: 'dueDiligence/index',
      component: () => import('./dueDiligence/index')
    },
    {
      // 购买运输
      path: 'buyShipping',
      name: 'buyShipping',
      component: () => import('./buyShipping/index')
    },
    {
      // 发起购买
      path: 'initiateBuy',
      name: 'initiateBuy/index',
      component: () => import('./initiateBuy/index')
    },
    {
      // 库房
      path: 'storeHouse',
      name: 'devOpsStoreHouse',
      component: () => import('./storehouse/index')
    },
    {
      // 库房
      path: 'storehouse/StoreHouse',
      name: 'StoreHouse',
      component: () => import('./storehouse/StoreHouse')
    },

    {
      // 库房总览
      path: 'warehouseSummary',
      name: 'warehouseSummary',
      component: () => import('./storehouse/warehouseSummary')
    },
    {
      // 价值管理
      path: 'valueManage',
      name: 'devOpsValueManage',
      component: () => import('./valueManage/index')
    },
    {
      // 运营管理跳转主页
      path: 'mochaItom/:art_id',
      name: 'mochaItom',
      component: () => import('./mochaItom/index')
    },
    {
      // 保险
      path: 'insurance',
      name: 'devOpsInsurance',
      component: () => import('./insurance/index')
    },
    // 续险-新增年度保险
    {
      path: 'resumeInsurance',
      name: 'resumeInsurance',
      component: () => import('./insurance/resumeInsurance')
    },
    // 新增年度保险
    {
      path: 'createAnnualInsurance',
      name: 'createAnnualInsurance',
      component: () => import('./insurance/annualInsurance/create')
    },
    // 新增运营保险
    {
      path: 'createOperateInsurance',
      name: 'createOperateInsurance',
      component: () => import('./insurance/operateInsurance/create')
    },
    // 保险赔付
    {
      path: 'payoutInsurance',
      name: 'payoutInsurance',
      component: () => import('./insurance/payoutInsurance/index')
    },
    // 新增保险赔付
    {
      path: 'createPayoutInsurance',
      name: 'createPayoutInsurance',
      component: () => import('./insurance/payoutInsurance/create')
    },
    {
      // 保险历史
      path: 'historyInsurance',
      name: 'historyInsurance',
      component: () => import('./insurance/historyInsurance')
    },
    {
      // 运输
      path: 'transport',
      name: 'devOpsTransport',
      component: () => import('./transport/index')
    },
    // 运输流程
    {
      path: 'transportFlow',
      name: 'devOpsTransportFlow',
      component: () => import('./transportFlow/index')
    },
    // 运输流程详情
    {
      path: 'transportFlowDetail',
      name: 'devOpsTransportFlowDetail',
      component: () => import('./transportFlow/operation/detail')
    },
    // 复制
    {
      path: 'copyFlow',
      name: 'devOpsCopyFlow',
      component: () => import('./copyFlow/index')

    },
    // 运维历史
    {
      path: 'devOpsHistory',
      name: 'devOpsHistory',
      component: () => import('./devOpsHistory/index')
    },
    // 拍摄
    {
      path: 'shotFlow',
      name: 'devOpsShotFlow',
      component: () => import('./shotFlow/index')
    },
    {
      // 藏品装裱
      path: 'artMount',
      name: 'artMount',
      component: () => import('./artMount/index')
    },
    {
      // 藏品修复
      path: 'artRepair',
      name: 'artRepair',
      component: () => import('./artRepair/index')
    },
    {
      // 藏品借展
      path: 'artLoanExhibition',
      name: 'artLoanExhibition',
      component: () => import('./artLoanExhibition/index')
    },
    {
      // 藏品出售
      path: 'artSell',
      name: 'artSell',
      component: () => import('./artSell/index')
    },
    {
      // 藏品出售出库
      path: 'artSellDelivery',
      name: 'artSellDelivery',
      component: () => import('./artSell/indexWarehouse.vue')
    },
    // 单个录入普通盘点信息
    {
      path: '/storageRoom/InventoryInformation',
      name: 'InventoryInformation',
      component: () => import('./storageRoom/InventoryInformation')
    },
    // 批量录入盘点信息
    {
      path: '/storageRoom/batcheEnterInventory',
      name: 'batcheEnterInventory',
      component: () => import('./storageRoom/batcheEnterInventory')
    },
    {
      path: 'transport/transportHistory/index',
      name: 'transportHistory',
      component: () => import('./transport/transportHistory/index')
    },
    {
      path: 'batchDetail',
      name: 'batchDetail',
      component: () => import('./batchDetail')
    },
    // 运营中作品
    {
      path: 'devOpsIngArt',
      name: 'devOpsIngArt',
      component: () => import('./devOpsIngArt/index')
    },
  ]
}



// WEBPACK FOOTER //
// ./src/pages/devOpsManage/router_devOpsManage.js